import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin(async () => {
  return {
    provide: {
      pdfMake: window.pdfMake
    }
  };
});
